import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'mprd-mobile-number-input',
  templateUrl: 'mobile-number-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileNumberInputComponent {
  mobileNumberForm: UntypedFormGroup;
  isMobileNumberInputFormHasErrors: boolean;
  @Output()
  mobileNumberInputFormStatusAndValue: EventEmitter<any> = new EventEmitter();

  constructor(private builder: UntypedFormBuilder) {
    this.mobileNumberForm = this.builder.group({
      mobileNumber: [
        '',
        [Validators.required, Validators.pattern('(04)+[0-9]{8}$')],
      ],
    });

    this.mobileNumberForm.valueChanges.subscribe((value) => {
      this.isMobileNumberInputFormHasErrors =
        this.mobileNumberForm.get('mobileNumber').dirty &&
        !this.mobileNumberForm.pending &&
        !this.mobileNumberForm.get('mobileNumber').valid;
      this.mobileNumberInputFormStatusAndValue.emit({
        mobileNumberFormStatus: this.mobileNumberForm.get('mobileNumber').valid,
        mobileNumber: this.mobileNumberForm.get('mobileNumber').value,
      });
    });
  }

  isNumberEmpty() {
    return this.mobileNumberForm.controls['mobileNumber']?.value.length === 0;
  }
}
